export default {"src":"/_next/static/media/icon_shield_white.8213223b.svg","height":19,"width":17,"blurWidth":0,"blurHeight":0};